$(document).ready(function() {
  $(".js-add-reading-btn").click(function() {
    html = $(this).siblings(".content").html();
    window.tinymce.activeEditor.setContent(window.tinymce.activeEditor.getContent() + html);
  });
});
